import React from 'react';

import styled from 'styled-components';
import { MdEmail } from 'react-icons/md';
import { SiWhatsapp } from 'react-icons/si';
import ContactForm from './contactForm';
import ContactInfoItem from './ContactInfoItem';
import SectionTitle from './SectionTitle';

const ContactSectionStyle = styled.div`
  padding: 10rem 0;
  .contactSection__wrapper {
    display: flex;
    gap: 5rem;
    margin-top: 7rem;
    justify-content: space-between;
    position: relative;
  }
  .contactSection__wrapper::after {
    position: absolute;
    content: '';
    width: 2px;
    height: 50%;
    background-color: var(--gray-1);
    left: 50%;
    top: 30%;
    transform: translate(-50%, -50%);
  }
  .left {
    width: 100%;
    max-width: 500px;
  }
  .right {
    max-width: 500px;
    width: 100%;
    border-radius: 12px;
    /* padding-left: 3rem; */
  }
  @media only screen and (max-width: 768px) {
    .contactSection__wrapper {
      flex-direction: column;
    }
    .contactSection__wrapper::after {
      display: none;
    }
    .left,
    .right {
      max-width: 100%;
    }
    .right {
      padding: 4rem 2rem 2rem 2rem;
    }
  }
`;

export default function ContactSection() {
  return (
    <ContactSectionStyle>
      <div className="container">
        <SectionTitle heading="contato" subheading="Deixe uma mensagem" />
        <div className="contactSection__wrapper">
          <div className="left">
            <a
              href="https://wa.me/5531999694300?text=Welcome+to+the+my+world%21"
              target="_blank"
              rel="noreferrer"
            >
              <ContactInfoItem icon={<SiWhatsapp />} text="+5531999694300" />
            </a>
            <a
              href="mailto:afreittaswill@gmail.com"
              target="_blank"
              rel="noreferrer"
            >
              <ContactInfoItem
                icon={<MdEmail />}
                text="afreittaswill@gmail.com"
              />
            </a>
            <a
              href="https://goo.gl/maps/81H9ZDLwVZjKpu9F7"
              target="_blank"
              rel="noreferrer"
            >
              <ContactInfoItem text="Letícia - Minas Gerais, Brasil" />
            </a>
          </div>
          <div className="right">
            <ContactForm />
          </div>
        </div>
      </div>
    </ContactSectionStyle>
  );
}
